// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"WW-z","sponsoredTooltipWrapper":"XW-z","sponsoredTooltip":"YW-z","newCard":"ZW-z"};